<template>
  <div class="inteBox">
    <hd-com></hd-com>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div :class="active == '2' ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('2')">在线问诊</div>
        <div :class="active == '1' ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('1')">电话问诊</div>
        <div :class="active == '3' ? 'left-btn1' : 'left-btn2'" @click="handleClickYu('3')">挂号预约</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="Content1Title">{{active == 2 ? '在线' : '电话'}}问诊列表</div>
          <el-tabs class="Content1Title" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(tabs, index) in tabData" :key="index" :label="tabs.label" :name="tabs.value" style="height: 100%">
              <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" height="calc(100vh - 300px)" >
                <!-- <el-table-column prop="orderNumber" label="订单编号"></el-table-column> -->
                <el-table-column prop="patientName" label="患者" align="center"> </el-table-column>
                <el-table-column prop="diseaseDiagnose" label="患者病症" align="center">
                  <template slot-scope="scope">
                    <span style="color: #00AFB5;">{{ scope.row.diseaseDiagnose ? scope.row.diseaseDiagnose : "-" }}</span> 
                  </template>
                </el-table-column>
                <el-table-column prop="doctorName" label="门诊医生" align="center"> </el-table-column>
                <el-table-column prop="payMoney" label="订单金额(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.payMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付方式" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.payType == 0">余额</p>
                    <p v-if="scope.row.payType == 1">微信</p>
                    <p v-if="scope.row.payType == 2">支付宝</p>
                    <p v-if="scope.row.payType == -1">取消支付</p>
                  </template>
                </el-table-column>
                <el-table-column prop="state" label="订单状态" align="center" width="160px">
                  <template slot-scope="scope">
                    <p v-if="scope.row.state == 0">待支付</p>
                    <div v-if="scope.row.state == 0" style="color:#EB3333" ><el-statistic
                          class="el-statistic1"
                              ref="statistic"
                              format="支付剩余: mm:ss"
                              :value="scope.row.countdownTime"
                              time-indices
                              @finish="hilarity"
                              style="color:#00AFB5"
                          ></el-statistic>
                    </div>
                    <p v-if="scope.row.state == 1">待接诊</p>
                    <div v-if="scope.row.state == 1" style="color:#EB3333" ><el-statistic
                          class="el-statistic1"
                              ref="statistic"
                              format="等待医生接诊: mm:ss"
                              :value="scope.row.countdownTime"
                              time-indices
                              @finish="hilarity"
                              style="color:#00AFB5"
                          ></el-statistic>
                    </div>
                    <p v-if="scope.row.state == 2">接诊中</p>
                    <p v-if="scope.row.state == 3">已完成</p>
                    <p v-if="scope.row.state == 4">已评价</p>
                    <p v-if="scope.row.state == -1">已取消</p>
                    <p v-if="scope.row.state == -3">已拒绝</p>
                    <p v-if="scope.row.state == -2">已退款</p>
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="下单时间" align="center" width="160px">
                  <template slot-scope="scope">
                    {{ scope.row.addTime | timefilters }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="250px">
                  <template slot-scope="scope">
                    <span class="danger optionBtn" @click="toCancleOrder(scope.row)" v-if="scope.row.state == 0">取消问诊</span>
                    <span class="primary optionBtn" @click="toPayDetail(scope.row)" v-if="scope.row.state == 0">立即付款</span>
                    <span class="danger optionBtn" @click="toRefundOrder(scope.row)" v-if="scope.row.state == 1">取消问诊</span>
                    <span class="primary optionBtn" @click="toCosDoc(scope.row)" v-if="scope.row.state == 2 && active == 2 && scope.row.userFinishState == 0">联系医生</span>
                    <span class="danger optionBtn" @click="toRefund(scope.row)" v-if="scope.row.state == 2 && active == 1 && scope.row.userFinishState == 0 && scope.row.doctorFinishState==1">拒绝完成</span>
                    <span class="primary optionBtn" @click="toTrueCom(scope.row)" v-if="scope.row.state == 2 && scope.row.doctorFinishState == 1">确认完成</span>
                    <span class="primary optionBtn" @click="ReplyBtn(scope.row)" v-if="scope.row.state == 3">评价</span>
                    <span class="primary optionBtn" @click="ReplyDetailBtn(scope.row)" v-if="scope.row.state == 4">评价详情</span>
                    <span class="danger optionBtn" @click="toDelete(scope.row)" v-if="scope.row.state == 3 || scope.row.state == 4 || scope.row.state == -1 || scope.row.state == -2 || scope.row.state == -3">删除</span>
                    <span class="info optionBtn" @click="toOrderDetail(scope.row)" v-if="scope.row.state == 2 || scope.row.state == 3 || scope.row.state == 4 || scope.row.state == -1 || scope.row.state == -2 || scope.row.state == -3">查看详情</span>
                  </template>
                </el-table-column>
                <el-table-column type="expand" >
                  <template slot-scope="scope" >
                    <el-row v-if="scope.row.refundRefuseReson">
                      <el-col :span="24">
                        <span style="color: #fd403b">拒绝原因：{{ scope.row.refundRefuseReson }}</span>
                      </el-col>
                    </el-row>
                    <el-row v-if="scope.row.userFinishRemar && scope.row.state == 2">
                      <el-col :span="24">
                        <span style="color: #fd403b">拒绝原因：{{ scope.row.userFinishRemark }}</span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @current-change="changePage" :page-size="pageSize" :current-page="pageIndex" :total="dataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
    <el-dialog title="请填写拒绝理由" :visible.sync="refuseDialog" width="450px" :append-to-body="true" :z-index="99999">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refuseReson">
          <el-input v-model="refuseForm.refuseReson" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')" :loading="isLoad">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="评论" :visible.sync="dialogFormVisible">
      <div style="width:500px;margin:0 auto">
            <div class="flex-start" style="margin-bottom:20px">
              <div style="margin-right: 10px">医生总评:</div>
              <el-rate v-model="star" text-color="#EB6C1B" show-text :texts="texts" :max="5"> </el-rate>
            </div>
            <div class="flex-start" style="margin-bottom:20px">
              <div style="margin-right: 10px">问诊结果:</div>
              <el-rate v-model="consultationResult" text-color="#EB6C1B" show-text :texts="texts1" :max="4"> </el-rate>
            </div>
            <div class="flex-start" style="margin-bottom:20px">
              <div style="margin-right: 10px">服务态度:</div>
              <el-rate v-model="serviceAttitude" text-color="#EB6C1B" show-text :texts="texts1" :max="4"> </el-rate>
            </div>
            <div class="flex-start" style="margin-bottom:20px">
              <div style="margin-right: 10px">响应时间:</div>
              <el-rate v-model="responseTime" text-color="#EB6C1B" show-text :texts="texts2" :max="4"> </el-rate>
            </div>
            <el-input class="diseaseBox" type="textarea" :autosize="{ minRows: 4 }" v-model="contentValue" autocomplete="off"> </el-input>

      </div>
      <div slot="footer" class="" style="text-align:right;margin-top:30px">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveReplyBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="评论详情" :visible.sync="dialogFormVisibleEva">
      <div style="width:500px;margin:0 auto;min-height:400px">
        <div>
          <div class="flex-start">
            <div style="margin-right: 10px">医生总评:</div>
            <el-rate v-model="contentDetail.star" text-color="#EB6C1B" show-text :texts="texts" :max="5" disabled> </el-rate>
          </div>
          <div class="flex-start">
            <div style="margin-right: 10px">问诊结果:</div>
            <el-rate v-model="contentDetail.consultationResult" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
          </div>
          <div class="flex-start">
            <div style="margin-right: 10px">服务态度:</div>
            <el-rate v-model="contentDetail.serviceAttitude" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
          </div>
          <div class="flex-start">
            <div style="margin-right: 10px">响应时间:</div>
            <el-rate v-model="contentDetail.responseTime" text-color="#ff9900" disabled show-text :texts="texts2" :max="4"> </el-rate>
          </div>
          <div>
            <div style="margin-right: 20px;margin-top: 20px;"></div>
            <div>{{ contentDetail.content || "" }}</div>
            <div style="margin-right: 20px; margin-top: 20px;background: #F5F5F5;border-radius: 8px;padding:20px;" v-if="contentDetail.replyContent">医生回复：{{ contentDetail.doctorName }}</div>
            <div>{{ contentDetail.replyContent || "" }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 聊天 -->
    <div class="jw-box" v-if="showJw" :style="{ 'padding-top': `20px` }">
      <i class="el-icon-close closeBtn" @click="showDialog"></i>
      <JwChat-index ref="jwChat" class="jw" :config="config" scrollType="scroll" :taleList="messageList" @enter="bindEnter" v-model="inputMsg" :toolConfig="tool" width="90%" height="calc(100vh - 134px)" @clickTalk="talkEvent" :quickList="config.quickList">
        <!-- 自定义插槽 -->
        <template v-slot:tools>
          <el-upload ref="upload" :headers="headers" :action="CommonFilePath" :limit="1" class="avatar-uploader" :show-file-list="false" :on-success="handleSuccess" accept=".png,.jpg,.jpeg,.gif" :before-upload="beforeUpload">
            <i class="el-icon-picture-outline" style="font-size: 20px; margin-left: 5px; margin-top: 8px"></i>
          </el-upload>
          <el-upload ref="uploadVideo" :headers="headers" :limit="1" class="avatar-uploader" :show-file-list="false" action="" :before-upload="beforeUploadVideo" accept=".mp4">
            <i class="el-icon-video-camera" style="font-size: 20px; margin-left: 5px; margin-top: 8px"></i>
          </el-upload>
        </template>
      </JwChat-index>
    </div>
  </div>
</template>
<script>
import hdCom from '../../components/header'
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
import { consultationMain } from "../../components/consultation/consultation";
import { Chathub } from "../../components/Chathub/Chathub";
import { videoMain } from "../../components/video/video";
var loading = null;
import '../../utils/aliyun-upload-sdk-1.5.3.min.js'
// import '../../utils/es6-promise.min.js'
import OSS from '../../utils/aliyun-oss-sdk-6.17.1.min.js'
window.OSS = OSS;
export default {
  components: {
    hdCom,
  },
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
    var userChat = new Chathub(this.TokenClient, this.Services.Chathub);
    var video = new videoMain(this.TokenClient, this.Services.Statics);
    return {
      DoctorAppointment: doctorAppointment,
      consultationDrugDomain:consultationDrugItem,
      videoDomain: video,
      UserChat: userChat,
      active: this.$route.query.type ? this.$route.query.type : '2',
      activeName: this.$route.query.payType ? this.$route.query.payType : '0',
      consultationResult:4,
      serviceAttitude:4,
      responseTime:4,
      star:0,
      contentValue:'',
      tabData: [
        {
          value: "0",
          label: "待支付",
        },
        {
          value: "1",
          label: "待接诊",
        },
        {
          value: "2",
          label: "接诊中",
        },
        {
          value: "3,4,-1,-2,-3",
          label: "已完成/取消",
        }
      ],
      userInfo: this.$store.state.localData.userInfo,
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageSize: 15,
      rules: {
        refuseReson: [{ required: true, message: "请填写拒绝接诊原因", trigger: "blur" }],
        replyContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      refuseForm: {
        id: 0,
        refuseReson: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
      contactDialog: false,
      detailInfo: {},
      texts: ["差评", "差评", "中评", "中评", "好评"],
      texts1: ["不满意", "一般", "满意", "很满意"],
      texts2: ["不及时", "一般", "及时", "很及时"],
      dialogFormVisible: false,
      form: {
        id: 0,
        replyContent: "",
        // replyUserId: 0,
        // replyUserName: "",
      },
      isLoad: false,
      payDetail:this.$route.query.type,
      orderId:'',
      dialogFormVisibleEva:false,
      contentDetail:{},
      // 聊天
      showJw: false,
      messageList: [], //消息列表
      inputMsg: "",
      tool: {
        show: [],
        showEmoji: false,
        callback: this.toolEvent,
      },
      config: {
        img: "",
        name: "",
        dept: "",
        callback: this.bindCover,
        historyConfig: {
          show: true,
          tip: "加载更多",
          callback: this.bindLoadHistory,
        },
        quickList: [{ text: "这里是jwchat，您想了解什么问题。" }, { text: "jwchat是最好的聊天组件" }],
      },
      docOrderNumber:'',
      userLogo: "https://api.qyyl365.com/authorization/PC/userlogo.png",
      shopLogo: "https://api.qyyl365.com/authorization/PC/shoplogo.png",
      groundId:'',
      resVideo: "", //视频地址
      uploader: null,
      videoId:''
    };
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + JSON.parse(localStorage.getItem("token")).value,
      };
    },
  },
  created() {
    window.goAgainClick = this.goAgainClick;
    window.goSureClick = this.goSureClick;
    this.getList();
    this.initChathubMsg()
  },
  destroyed() {
    // 问诊聊天
    window.removeEventListener("ReceiveToUserMsg", this.getChathubSocketData);
  },
  methods: {
    handleClickYu(){
      this.$router.push({
        path: "/reservation/reservationOrderList",
        type:'3'
      });
    },
    initChathubMsg() {
      window.addEventListener("ReceiveToUserMsg", this.getChathubSocketData);
      // 检测浏览器是否支持Websocket
      if (typeof WebSocket == "undefined") {
        this.$alert("系统检测到您的浏览器不支持Websocket通信协议，这将会导致您无法正常进行课堂互动！建议您更换浏览器进行观看！", "警告", {
          confirmButtonText: "知道了",
          callback: () => {},
        });
      }
    },
    getMessagesBygroupId() {
      var _this = this;
      _this.UserChat.GetDiseaseGroupHistoryChatMessageData(
        _this.docOrderNumber,
        function (data) {
          let messageList = [];
          _this.messageList = []
          let array = data.data;
          array.forEach((item) => {
              var text = _this.getMsgStr(item.contentType, item.content);
              var message = {
                id: item.id, //消息编号
                // SessionId: item.SessionId, //会话编号
                groupId: item.groupId,
                FromUserId: item.fromUserId, //发送者
                To: item.toUser, //接收者，MsgType=USER时为用户ID，MsgType=GROUP时为群ID
                MsgType: item.msgType, //消息类型，同item.SessionType
                mine: item.fromUserId == _this.userInfo.id ? true: false,
                img: item.fromUserId == _this.userInfo.id ? (_this.userInfo.photo ? _this.Services.ossUpload +  _this.userInfo.photo : _this.userLogo) : _this.shopLogo,
                name: item.fromUserId == _this.userInfo.id  ? _this.userInfo.name : item.signalRGroup.doctorName,
                date: _this.timefilters(item.sendTime), //发送时间
                text: text, //正文
                Timestamp: _this.timeFormat(item.sendTime),
                ContentType: item.contentType, //正文类型
              };
              messageList.push(message);
          });
          if (messageList.length > 0) {
            if (_this.messageList.length == 0) {
              _this.messageList = messageList.concat(_this.messageList);
            }
            else {
              _this.messageList = messageList.concat(_this.messageList);
            }
            _this.$nextTick(() => {
              _this.$refs.jwChat.finishPullDown();
            });
          } 
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    timefilters(val) {
      if (val == null || val == "") {
        return "-";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
        return times;
      }
    },
    getAge(date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    /**
     * 日期转时间戳
     * @param val
     */
    timeFormat(val) {
      const date = new Date(val); // 获取当前日期对象
      return date.getTime();
    },
    getMsgStr(contentType, content) {
      var text = { text: `${content}` };
      if (contentType == "image") {
        text = { text: "<img data-src='" + `${this.CommonPath}${content}` + "'/>" };
      } else if (contentType == "video") {
        text = { text: `<video width="745" height="420" controls="controls" data-src=${content} />` };
      } else if (contentType == "doctorDesc") {
        var msgInfo = JSON.parse(content);
        let img1 = `https://oss.qyyl365.com/PC/touxiang.png`;
        if (msgInfo?.photoFile) {
          img1 = `${this.CommonPath}${msgInfo?.photoFile}`;
        }
        let img2 = `https://oss.qyyl365.com/PC/yirenzheng.png`;
        text = {
          text: `<div style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 20px auto;'><div class="flex-start userInfo" style='margin: 5px 0;'><img style='width: 45px;height: 45px;border-radius: 50%;margin-right:5px' src="${img1}" /><div><div class="flex-start"><div style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.doctorName} ${msgInfo.departmentName}</div><img style="margin-right: 5px" src="${img2}" /></div><div style='color: #666666;font-size: 12px;text-align: left;'>证书编号：${msgInfo.certificateNumber}</div></div></div><div class="desc twoLine" style='line-height: 1.4;font-size: 12px;text-align: left;' v-if="${msgInfo.profile}">简介:${msgInfo.profile}</div></div>`,
        };
      } else if (contentType == "caseCard") {
        var msgInfo = JSON.parse(content);
        let sex = `${msgInfo.sex ? "男" : "女"}`;
        let age = `${this.getAge(msgInfo?.birthday)}岁`;
        let birthday = `(${msgInfo.birthday?.split("T")[0]})`;
        let relationshipToPatient = "";
        switch (msgInfo.relationshipToPatient) {
          case 0:
            relationshipToPatient = "本人";
            break;
          case 1:
            relationshipToPatient = "子女";
            break;
          case 2:
            relationshipToPatient = "父母";
            break;
          case 3:
            relationshipToPatient = "其他";
            break;
        }
        text = {
          text: `<div class="box" style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 20px auto;'><div class="flex-space-between top-title" style='margin-bottom: 5px;'><h4>病历卡</h4><div class="topRighgt-btn" style='color: #00afb5;font-size: 12px;'></div></div><div class="userInfo" style='margin: 5px 0;'><div class="doctor-1" style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.patientName} ${msgInfo.departmentName}${sex} ${age}${birthday} ${relationshipToPatient}</div><div class="desc flex-start" style="text-align: left; margin: 5px 0; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>就诊疾病：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.diseaseDiagnose}</div></div><div class="desc flex-start" style="text-align: left; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>病情描述：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.description}</div></div></div></div>`,
        };
      } 
      else if (contentType == "isEnd") {
        text = {
          text: `<div class="box" style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 20px auto; display: flex;align-items: center;flex-direction: column;'><div>医生已结束本次问诊，请确认完成</div><div class="" style="margin-top:20px;display: flex;align-items: center;"><div style="width:100px;background: #5E7FEA;border-radius: 4px;font-size: 16px;color: #FFFFFF;text-align: center;padding: 5px 0;cursor: pointer;" onclick="goAgainClick()">继续沟通</div><div style="width: 100px;background: #00AFB5;border-radius: 4px;font-size: 16px;color: #FFFFFF;text-align: center;padding: 5px 0;margin-left: 10px;cursor: pointer;" onclick="goSureClick()">确认完成</div></div></div>`,
        };
      }
      return text;
    },
    goAgainClick(){
      this.sendEnter(this.$chathubService.groundId , "message", '继续沟通', this.userInfo.id, false);
    },
    goSureClick(){
      let item = {
        orderNumber:this.docOrderNumber
      }
      this.toTrueCom(item)
      this.showJw = false
    },
    beforeUploadVideo(file) {
      //上传文件的大小
      const isLt20M = file.size / 1024 / 1024 < 200;
      //'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb','video/mp4' 可支持上传的视频类型
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt20M) {
        this.$message.error("上传视频大小不能超过200MB哦!");
        return false;
      }
      loading = this.$loading({
        lock: true,
        // text: '正在上传视频...',
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
      });
      let fileStr = file;
      this.$refs.uploadVideo.clearFiles();
      this.uploader = this.createUploader();
      var userData = '{"Vod":{}}';
      this.uploader.addFile(fileStr, null, null, null, userData);
      this.uploader.startUpload();
    },
      createUploader() {
      let _this = this;
      var uploader = new AliyunUpload.Vod({
        userId: "1922508017966810",
        //上传到点播的地域，默认值为'cn-shanghai'，//eu-central-1，ap-southeast-1，更多信息请参见存储说明
        region: "cn-shanghai",
        //开始上传
        addFileSuccess: function (uploadInfo) {
          console.log(uploadInfo);
        },
        onUploadstarted: function (uploadInfo) {
          let params = {
            title: "视频名称",
            fileName: uploadInfo.file.name,
          };
          _this.videoDomain.VideoCertificate(
            params,
            function (data) {
              uploader.setUploadAuthAndAddress(uploadInfo, data.data.uploadAuth, data.data.uploadAddress, data.data.videoId);
              _this.videoId = data.data.videoId;
            },
            function (error) {
              _this.$message.error("视频上传失败！");
              loading.close();
            }
          );
          // }
        },
        //文件上传成功
        onUploadSucceed: function (uploadInfo) {
          _this.resVideo = "http://video.qyyl365.com/" + uploadInfo.object;
          let videoPath = "http://video.qyyl365.com/" + uploadInfo.object;
          loading.close();
          if (videoPath) {
            _this.sendEnter(_this.$chathubService.groundId, "video", videoPath, _this.userInfo.id, false);
          }
        },
        //文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          loading.close();
          uploader.stopUpload();
        },
        //文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          // _this.percentage = parseInt((loadedPercent * 100).toFixed(2))
        },
        //上传凭证过期
        onUploadTokenExpired: function (uploadInfo) {
          console.log("1111111");
          // loading.close();
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          _this.uploaded = true;
        },
      });
      return uploader;
    },
    beforeUpload() {
      loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
      });
    },
    handleSuccess(response, file, fileList) {
      loading.close();
      var _this = this;
      let res = response;
      this.$refs.upload.clearFiles();
      res.forEach(function (file) {
        var imgPath = file.completeFilePath;
        _this.sendEnter(_this.$chathubService.groundId , "image", imgPath, _this.userInfo.id, false);
      });
    },
    talkEvent(play) {
      console.log(play);
    },
    async bindEnter() {
      const msg = this.inputMsg;
      if (!msg) return;
      this.sendEnter(this.$chathubService.groundId , "message", msg, this.userInfo.id, false);
    },
    getChathubSocketData(res) {
      if (res.type == "ReceiveToUserMsg") {
        let message = JSON.parse(res.detail.data);
        console.log(message)
        // 处理接收到的消息，此处仅打印到控制台
        if (message.id) {
            this.getMessagesBygroupId();
        }
      }
    },
    async sendEnter(groupID, contentType, content, fromUserId, isServer) {
      console.log(groupID)
      let map = [groupID, contentType, content, Number.parseInt(fromUserId), isServer];
      const message = {
        protocol: "json",
        version: 1,
        arguments: map,
        target: "SendMessageToUser",
        type: 1, // 表示调用方法
      };
      try {
        console.log("发送消息", contentType, content);
        this.$chathubService.sendWebsocket(JSON.stringify(message) + "\u001E");
      } catch (ex) {
        console.log("消息发送失败，重新发送。", ex.toString());
        this.$chathubService.sendWebsocket(JSON.stringify(message) + "\u001E");
      }
    },
    showDialog() {
      this.showJw = false

    },
    toCosDoc(e){
       this.docOrderNumber = e.orderNumber
      this.showJw = true
      this.messageList = [];
      // 连接聊天
      let token = JSON.parse(localStorage.getItem(this.ClientId + 'Token')).access_token;
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$chathubService.connectChathubService(this.Services, userInfo, token ,e.organizationId, e.orderNumber );
      this.groundId = this.$chathubService.groundId 
      this.getMessagesBygroupId()
    },
      hilarity(){
        this.getList();
      },
      toOrderDetail(item){
        this.$router.push({
          path: "/consultation/ConsultationInfo",
          query: {
            orderId: item.orderNumber,
          },
        });
      },
      toPayDetail(e){
        var _this = this
        let orderParams = {
          orderNumber:e.orderNumber,
          totalMoney:e.totalMoney,
          patientName:e.patientName,
          patientDis:e.disease,
          sexTab:e.patientType,
          countdownTime:e.countdownTime,
          doctorName:e.doctorName,
          organizationName:e.organizationName,
          photoFile:e.photoFile,
          certificateNumber:e.certificateNumber,
          userCategoryType:e.userCategoryType,
          orderType:e.orderType,
          phone:e.phone
        }
        _this.$router.push({
            path: "/consultation/cosDocOrderPay",
            query: {
                payInfo: JSON.stringify(orderParams)
            },
        })
      },
      toRefundOrder(e){
        var _this = this
        _this.$confirm('此操作将取消问诊, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.consultationDrugDomain.GetCancelConsultationOrder(
            e.orderNumber,
            function (data) {
              console.log(data)
              if (data.code == '400') {
                  _this.$message({
                    type: "error",
                    message: data.msg,
                  });
              }
              if (data.code == '200') {
                  _this.$message({
                    type: "success",
                    message: "取消问诊成功!",
                  });
                  _this.getList();
              }
            },
            function (err) {
              console.log(err)
              var jsonObj = JSON.parse(err);
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          );
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消问诊'
          });          
        });

      },
      toCancleOrder(e){
        var _this = this
        _this.$confirm('此操作将取消问诊, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.consultationDrugDomain.GetDeleteOrder(
            e.orderNumber,
            function (data) {
              console.log(data)
              if (data.code == '400') {
                  _this.$message({
                    type: "error",
                    message: data.msg,
                  });
              }
              if (data.code == '200') {
                  _this.$message({
                    type: "success",
                    message: "取消问诊成功!",
                  });
                  _this.getList();
              }
            },
            function (err) {
              console.log(err)
              var jsonObj = JSON.parse(err);
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          );
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消问诊'
          });          
        });
    },
    toDelete(e){
      var _this = this;
      this.$confirm("确定删除该问诊订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _this.consultationDrugDomain.GetDeleteOrder(
            e.orderNumber,
            function (data) {
              _this.$message({
                type: "success",
                message: "删除成功!",
              });
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    ReplyBtn(e) {
      var _this = this
      _this.orderId = e.id
      _this.star = 0
      _this.consultationResult = 4
      _this.serviceAttitude = 4
      _this.responseTime = 4
      _this.contentValue = ''
      _this.dialogFormVisible = true;
    },
    delBtn(item) {
      var _this = this;
      this.$confirm("确定删除该评论?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _this.DoctorAppointment.DeleteEvaluate(
            item.id,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    ReplyDetailBtn(e){
      var _this = this
      _this.dialogFormVisibleEva = true;
      _this.consultationDrugDomain.GetConsultationEvaluateDetail(
        e.id,
        function (data) {
          _this.contentDetail = data.data
        },
        function (err) {
          console.log(err);
        }
      );
    },
    saveReplyBtn(e) {
      var _this = this;
      if (_this.star == 0) {
        _this.$message({
          type: "error",
          message: '请给医生打星',
        });
        return
      }
      if (_this.contentValue == '') {
        _this.$message({
          type: "error",
          message: '评价内容不能为空',
        });
        return
      }
      let params = {
        star:_this.star,
        consultationResult:_this.consultationResult,
        serviceAttitude:_this.serviceAttitude,
        responseTime:_this.responseTime,
        content:_this.contentValue,
        orderId:_this.orderId,
        userName:_this.userInfo.userName,
        userAvatar:_this.userInfo.photoFile,
        userPhone:_this.userInfo.phone,
        userId:_this.userInfo.id
      }
      _this.consultationDrugDomain.GetSubmitEvaluate(
        params,
        function (data) {
          _this.star = 0
          _this.consultationResult = 4
          _this.serviceAttitude = 4
          _this.responseTime = 4
          _this.contentValue = ''
          _this.$message({
              type: "success",
              message: "评价成功!",
          });
          _this.dialogFormVisible = false;
          _this.getList();
        },
        function (err) {
          console.log(err);
        }
      );
    },
    getList() {
      var _this = this;
      _this.tableData = [];
        _this.consultationDrugDomain.GetUserOrderListData(
          _this.active,
          _this.activeName,
          _this.pageIndex,
          _this.pageSize,
          function (data) {
            _this.tableData = data.data.results;
            _this.tableData.map((res)=>{
              if (res.state == 0) {
                res.countdownTime = new Date(res.addTime).getTime() + 60*15*1000;
              }
              if (res.state == 1) {
                res.countdownTime = new Date(res.paySuccessTime).getTime() + 60*30*1000;
              }
            })
            _this.pageIndex = data.data.pageIndex;
            _this.pageSize = data.data.pageSize;
            _this.dataTotal = data.data.dataTotal;
          },
          function (err) {
            console.log(err);
          }
        );
    },
    toConfirm(item) {
      var _this = this;
      _this.DoctorAppointment.ConfirmOrder(
        item.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    complateBtn() {
      var _this = this;
      _this.DoctorAppointment.DoctorCompleteOrder(
        _this.detailInfo.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.contactDialog = false;
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    toRefund(item) {
      this.refuseDialog = true;
      this.refuseForm = {
        id: item.orderNumber,
        refusalReason: "",
        state: item.state,
      };
    },
    toTrueCom(item){
      var _this = this;
      this.$confirm("确定要完成本次问诊吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          _this.consultationDrugDomain.GetUserCompleteOrder(
            item.orderNumber,
            '1',
            '%20',
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.getList();
            },
            function (err) {
              _this.isLoad = false;
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
          })
      .catch(() => {});

    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.isLoad = true;
          var item = _this.refuseForm;
            _this.consultationDrugDomain.GetUserCompleteOrder(
              _this.refuseForm.id,
              '2',
              item.refuseReson,
              function (data) {
                _this.isLoad = false;
                _this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                _this.$refs[formName].resetFields();
                _this.refuseDialog = false;
                _this.getList();
              },
              function (err) {
                _this.isLoad = false;
                var jsonObj = JSON.parse(err.msg);
                if (jsonObj.code == "400") {
                  _this.$message({
                    type: "error",
                    message: jsonObj.msg,
                  });
                }
              }
            );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    handleClickBtn(e) {
      this.active = e;
      this.pageIndex = 1;
      this.dataTotal = 0;
      this.getList();
    },
    handleClick(e) {
      this.pageIndex = 1;
      this.dataTotal = 0;
      this.searchForm = {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        payType: "-1",
        star: 0,
      };
      this.getList();
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    Search(event) {
      this.pageIndex = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}
.titleTopLeftImg {
  width: 123px;
  height: 24px;
}
.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}
.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}
.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}
.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}
.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titleTopRight div {
  margin-left: 10px;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  /* max-height: 750px; */
  overflow: auto;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
}
.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* .Content1Title {
  padding: 20px 40px;
  padding-left: 0;
  font-size: 18px;
  color: #333333;
  padding-bottom: 0;
  text-align: left;
  
} */
.Content1Title {
  padding: 20px 40px;
  padding-left: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 0;
  text-align: left;
}
.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}
.ageInput {
  width: 80%;
}
.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}
.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}
.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}
.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}
.stepInput {
  width: 60%;
  margin-right: 10px;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.drawer-box {
  padding: 30px;
}
.el-drawer {
  background-color: #ffffff !important;
  width: 550px !important;
}
.el-drawer__body {
  overflow: auto;
}
.detail-item {
  position: relative;
  margin-bottom: 20px;
}

.detail-item .detail-tit {
  font-size: 18px;
}

.detail-item > p {
  margin: 5px 0;
}

.detail-item > p span {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.detail-item .status {
  position: absolute;
  right: 5px;
  top: 5px;
}

.detail-item .status .text-orange {
  color: orange;
}

.detail-item .status .text-blue {
  color: rgb(47, 0, 255);
}

.detail-item .status p.text-danger {
  color: red;
}

.detail-item .status p.text-succes {
  color: forestgreen;
}
 ::v-deep .el-statistic1 .con  {
    color: #EB3333 !important;
    
}
::v-deep .el-statistic1 .con .number {
  font-size: 14px !important;
}
 .diseaseBox ::v-deep textarea{
    background: #F5F5F5 !important;
    /* border-radius: 4px; */
    border: none;
}
.jw-box {
  position: absolute;
  width: 100vw;
  width: 100%;
  top: 73px;
  left: 0;
  right: 0;
  height: calc(100vh - 100px);
  background: #f5f6fa;
  z-index: 2000;
  font-size: 16px;
}

.closeBtn {
  position: absolute;
  right: calc(10% + 10px);
  top: 30px;
  z-index: 999999999;
  color: #000;
  font-size: 20px;
  cursor: pointer;
}
.jw{
  width: 80% !important;
  margin: 0 auto !important;
}
.jw /deep/ .windowBar {
  border: 1px solid #eaeaea;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
  padding:0 10px;
  border-radius: 12px 0 0 12px;
}
.jw /deep/ .wrapper .web__main {
  width: 94%;
  padding: 0;
  left: 3%;
}

.jw /deep/ .wrapper {
  width: 100%;
  height: 100%;
}
/**左侧 */
.jw /deep/ .windowBar .winItem {
  border: none;
  height: auto !important;
  margin: 5px 0;
  padding: 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start !important;
  align-items: center;
}

.jw /deep/ .windowBar .winItem .itemOperation {
  display: none;
}
.jw /deep/ .windowBar .winItem:hover {
  background: #f5f7fa;
  border-radius: 4px;
}

.jw /deep/ .windowBar .winActive {
  background: #f5f7fa !important;
  border-radius: 4px;
}
.jw /deep/ .windowBar .info .name {
  color: #333;
  font-size: 14px;
  width: calc(14vw - 80px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  /* line-height: 1; */
}
.jw /deep/ .windowBar .info .dept {
  color: #999;
  font-size: 12px;
  line-height: 1;
  width: calc(14vw - 80px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.jw /deep/ .windowBar .winBarBox {
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
}

.jw /deep/ .winBarBox .item .el-badge {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}

.jw /deep/ .winBarBox .item .el-badge img {
  border-radius: 4px;
}

.jw /deep/ .winBarBox .bscroll-vertical-scrollbar {
  display: none !important;
}
.jw /deep/ .chatBox .bscroll-vertical-scrollbar {
  display: none !important;
}
.jw /deep/ .winBarBox .item .cover {
  position: absolute;
  top: 4px;
  left: 0;
  border-radius: 0;
}
.jw-box /deep/ .ChatPage .winBar {
  border-right: 5px solid #f0f2f5;
  /* border-radius: 12px 0 0 12px; */
}
.jw-box /deep/ .ChatPage .ChatPage-main .main {
  width: calc(100%) !important;
}
/* 中间 */
.jw-box /deep/ .ChatPage .header {
  /* background-color: #01c2ac; */
  background: #ffffff !important;
  border-radius: 4px;
  border-bottom: 5px solid #f0f2f5;
  border-radius: 0px 12px 0 0;
}

.jw-box /deep/ .wrapper .web__main .web__main-arrow:after {
  border-right-color: #f5f7fa;
}

.jw-box /deep/ .wrapper .web__main .web__main-item--mine .web__main-text .web__main-arrow:after {
  border-left-color: #f5f7fa;
}
.jw-box /deep/ .ChatPage .ChatPage-main .info p {
  /* background-color: #01c2ac; */
  font-size: 16px !important;
  color: #333333 !important;
}
.jw-box /deep/ .ChatPage {
  margin-left: 5%;
  border-radius: 12px;
}
/* .jw-box /deep/ .ChatPage .ChatPage-main .main .rightBox .switch {
  display: none;
} */

.jw-box /deep/ .wrapper .web__main .web__main-text {
  background: #f5f7fa;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}
.jw-box /deep/ .ChatPage .ChatPage-main .main .rightBox {
  width: 0;
  border:none;
  box-shadow: none;
  padding: 5px 0;
}

.jw-box /deep/ .wrapper .userList {
  display: none;
}
.jw-box /deep/ .wrapper .notice {
  height: 100%;
}
/* .jw-box /deep/ .ChatPage .rightBox .info p {
  color: #666;
}
.jw-box /deep/ .ChatPage .rightBox .item .cover {
  border-radius: 0;
} */
.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text {
  border-radius: 10px;
  background: #f5f7fa;
  border: none;
}

.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text {
  color: #333;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}

.jw /deep/ .el-button--primary {
  background-color: #01c2ac;
  border-color: #01c2ac;
}

.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text .web__main-arrow {
  border-left-color: #f5f7fa;
}
.jw /deep/ .wrapper .downBtn-position{
  width: 28px;
  height: 28px;
  bottom: 40px;
  right: 14px;
}
.jw /deep/ .wrapper .downBtn:before {
  content: "▼";
  color: #cacaca;
  background: #eee;
  font-size: 12px;
  padding-top: 2px;
  width: 28px;
  height: 28px;
}

.jw /deep/ .wrapper .downBtn:hover:before {
  color: #fff;
  background: #01c2ac;
}

.jw /deep/ .bscroll-indicator {
  background: #eee !important;
}
.jw /deep/ .wrapper .web__main .web__main-user img {
  width: 35px;
  height: 35px;
  border-radius: 5px !important;
}
.jw /deep/ .wrapper .web__main .web__main-item {
  margin-top: 10px;
}
.jw /deep/ .wrapper .web__main .web__main-user cite {
  top: -5px;
}
.jw /deep/ .wrapper .web__main .web__main-item--mine cite {
  top: -5px;
}
.jw /deep/ .wrapper .web__main .web__main-user cite i {
  padding-left: 0;
}
.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-user cite i {
  padding-right: 0;
}
.jw /deep/ .wrapper .web__main .web__main-text {
  padding: 5px 15px;
  margin-top: 20px;
  border-radius: 10px;
  color: #333;
}
.header :deep() .el-badge__content.is-dot {
  width: 12px;
  height: 12px;
}
.jw-box /deep/ .chatPage .toolBox {
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.05);
}
.canBtnBox {
    width: 80px;
    background: #EDEDED;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
}
.stepBtnBox {
    width: 180px;
    background: #00AFB5;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
     padding: 5px 0;
    margin-left: 10px;
    cursor: pointer;
}
</style>